// extracted by mini-css-extract-plugin
export default {"serviceContainer":"serviceContainer__dequCnl0","serviceColumn":"serviceColumn__X7evC6Ik"};